import { useState } from 'react';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Staging } from '@/services/configurator/Staging';
import { useEnv } from '@/components/providers/env-provider';
import { DeleteIcon } from 'lucide-react';

export type PlannerPublishDeleteDialogProps = {
  name: string;
  id: string;
  onDelete: () => void;
};

export function PlannerPublishDeleteDialog(
  props: PlannerPublishDeleteDialogProps,
) {
  const [open, setOpen] = useState(false);

  const { env } = useEnv();

  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        setOpen(open);
      }}
    >
      <DialogTrigger asChild>
        <Button
          className='gap-2 h-8 border-solid border-2 rounded p-4 border-destructive'
          variant='destructive'
        >
          <DeleteIcon className='h-4 w-4 min-[800px]:hidden' />
          <span className='max-[800px]:hidden'>Delete</span>
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{`Delete ${props.name}?`}</DialogTitle>
          <DialogDescription>
            {`Delete staged data? ID: ${props.id}`}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className='sm:justify-end'>
          <Button
            type='button'
            variant='secondary'
            onClick={() => {
              setOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            type='button'
            variant='destructive'
            onClick={() => {
              setOpen(false);
              new Staging(env).deletePlanner(props.id).then(() => {
                toast.success(`Deleted ${props.id}`);
                props.onDelete();
              });
            }}
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
